// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import { createAuthStorage } from '@/utils/cookieStorage';

const SUPABASE_URL = "https://arikhtozvkvxlraiuenh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFyaWtodG96dmt2eGxyYWl1ZW5oIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA1MTUzNDYsImV4cCI6MjA2NjA5MTM0Nn0.dlbYO0MDYeUENh9tYSJb7ctfxGFEhyahDJ4Ia00WCNU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Initialize Supabase client with secure session management
export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: createAuthStorage(),
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce', // Use PKCE flow for enhanced security
  },
  global: {
    headers: {
      'X-Client-Info': 'oreog-web-app',
    },
  },
});